import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from 'axios';
import { Lead, NewLead, EditLead, LeadResponse, LeadsFilters, UploadLeadResponse } from "../../models/Lead";
import { axiosClient } from "../axiosClient";
import { Client } from "../../models/Client";
import { User } from "../../models/User";

export const fetchLeads = createAsyncThunk("leads", async (data: {page: number, pageSize: number, filters: LeadsFilters, changeLeads: Boolean}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<LeadResponse> = await (await axiosClient()).patch(`/leads?page=${data.page}&pageSize=${data.pageSize}`, {...data.filters});
        return {
            ...response.data,
            filters: data.filters,
            changeLeads: data.changeLeads
        };
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const fetchLeadById = createAsyncThunk("leads/getLeadById", async (id: number) => {
    const response: AxiosResponse<Lead> = await (await axiosClient()).get(`/leads/${id}`);
    return response.data;
});

export const fetchLeadsPool = createAsyncThunk("leadsPool", async (data: {page: number, pageSize: number, filters: LeadsFilters}) => {
    const response: AxiosResponse<LeadResponse> = await (await axiosClient()).patch(`/leads/unassigned-pool?page=${data.page}&pageSize=${data.pageSize}`, {...data.filters});
    return {
        ...response.data,
        filters: data.filters
    };
});

export const createLead = createAsyncThunk("leads/createLead", async (params: {lead: Lead, assignedAgentId?: number, currentUser: User}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<Lead> = await (await axiosClient()).post(`/leads?assignedAgentId=${params.assignedAgentId}`, { ...params.lead });
        return {
            lead: response.data,
            currentUser: params.currentUser
        };
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const deleteLead = createAsyncThunk("leads/deleteLead", async (params: {leadId: number, page: number, pageSize: number}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<LeadResponse> = await (await axiosClient()).delete(`/leads/${params.leadId}?page=${params.page}&pageSize=${params.pageSize}`);
        return response.data
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const createAutomationLead = createAsyncThunk("leads/createAutomationLead", async (params: { lead: NewLead, automationId: number }, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<Lead> = await (await axiosClient()).post(`/automations/entry-lead`, { ...params.lead }, { params: { automationId: params.automationId } });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const updateLead = createAsyncThunk("leads/updateLead", async (params: { lead: Lead, leadId: number }, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<Lead> = await (await axiosClient()).patch(`/leads/${params.leadId}`, { ...params.lead });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const uploadAgentLeads = createAsyncThunk("leads/uploadAgentLeads", async (leads: any, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<Lead[]> = await (await axiosClient()).post(`/leads/upload`, leads);
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const uploadAgencyLeads = createAsyncThunk("leads/uploadAgencyLeads", async (params: {agencyId: number, isFromPool: boolean, leads: any}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<UploadLeadResponse> = await (await axiosClient()).post(`/leads/upload-multiple?agencyId=${params.agencyId}&isFromPool=${params.isFromPool}`, params.leads);
        return {
            ...response.data,
            isFromPool: params.isFromPool
        }
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const startLeadAutomation = createAsyncThunk("leads/startAutomation", async (params: {phone: any, automationId: number }, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<any> = await (await axiosClient()).post(`/automations/start-automation`, undefined, { params: { phone: params.phone, automationId: params.automationId } });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const assignLeadFromPool = createAsyncThunk("leads/assignLeadFromPool", async (params: {leadId: number}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<Lead> = await (await axiosClient()).put(`/leads/${params.leadId}/assign-lead-pool`);
        return response.data
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const pastPage = createAsyncThunk("leads/pastPage", async () => {
    return true;
});

export const pastPoolPage = createAsyncThunk("leads/pastPoolPage", async () => {
    return true;
});

export const updateLeadClient = createAsyncThunk("leads/updateLeadClient", async(createdClient: Client) => {
    return createdClient;
});

export const setLeadsActiveTab = createAsyncThunk("leads/setLeadsActiveTab", async (activeTab: Number) => {
    return activeTab;
});
export const checkLeadPhoneNumber = createAsyncThunk("leads/checkLeadPhoneNumber", async (data: {phone: string}) => {
    const response: AxiosResponse<Lead[]> = await (await axiosClient()).get(`/leads/check-phone?phone=${data.phone}`);
    return response.data;
});